/* Load motion only near the viewport. Posters remain visible if playback fails. */
(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const states = new Set();
  function init(root = document) {
    root.querySelectorAll('[data-ir-media]').forEach(frame => {
      if (frame.dataset.initialized) return;
      frame.dataset.initialized = 'true';
      const video = frame.querySelector('video');
      const button = frame.querySelector('[data-ir-toggle]');
      if (!video || !button) return;
      const state = {frame, video, button, visible: false, manuallyPaused: false, requested: false};
      states.add(state);
      button.hidden = false;
      function sync() {
        const playing = !video.paused;
        frame.classList.toggle('is-playing', playing);
        button.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
        button.setAttribute('aria-pressed', String(playing));
        button.querySelector('[data-ir-toggle-label]').textContent = playing ? 'Pause film' : 'Play film';
        button.querySelector('[data-ir-toggle-icon]').textContent = playing ? 'Ⅱ' : '▶';
      }
      function load() {
        if (video.dataset.loaded) return;
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.dataset.loaded = 'true';
        video.load();
      }
      state.play = () => {
        load();
        video.play().then(() => { frame.classList.add('is-ready'); sync(); }).catch(sync);
      };
      state.update = () => {
        if (state.visible && !document.hidden && !state.manuallyPaused && (!motion.matches && !connection?.saveData || state.requested)) state.play();
        else video.pause();
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', () => { frame.classList.remove('is-ready', 'is-playing'); button.hidden = true; });
      video.querySelector('source')?.addEventListener('error', () => { frame.classList.remove('is-ready', 'is-playing'); button.hidden = true; });
      button.addEventListener('click', () => {
        if (video.paused) { state.manuallyPaused = false; state.requested = true; state.play(); }
        else { state.manuallyPaused = true; video.pause(); }
      });
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(entries => { state.visible = entries[0].isIntersecting; state.update(); }, {threshold: 0.08});
        state.observer.observe(frame);
      }
      sync();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach(state => { if (event.target.contains(state.frame)) {state.observer?.disconnect();state.video.pause();states.delete(state);} });
  });
  document.addEventListener('visibilitychange', () => states.forEach(state => state.update()));
  motion.addEventListener('change', () => states.forEach(state => {state.requested = false;state.update();}));
})();

(() => {
 const board = new URLSearchParams(location.search).get('board');
 if (!board || !location.pathname.endsWith('/pages/contact')) return;
 const field = document.querySelector('textarea[name="contact[body]"]');
 if (field && !field.value) field.value = `Hi, I’d like to know more about the ${board.slice(0,150)}.\n\n`;
})();

document.addEventListener('click', async event => {
 const link = event.target.closest('#sidebar-menu a');
 if (!link) return;
 const destination = new URL(link.href, location.href);
 const menu = document.getElementById('sidebar-menu');
 if (destination.pathname === location.pathname && destination.hash) {
  const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  await menu?.hide();
  history.pushState(null, '', destination.hash);
  target.scrollIntoView({block: 'start', behavior: 'instant'});
  target.setAttribute('tabindex', '-1');
  target.focus({preventScroll: true});
 } else {
  menu?.hide();
 }
}, true);
